export var PermissionName;
(function (PermissionName) {
    PermissionName["READ"] = "READ";
    PermissionName["WRITE"] = "WRITE";
    PermissionName["DELETE"] = "DELETE";
    PermissionName["EXECUTE"] = "EXECUTE";
})(PermissionName || (PermissionName = {}));
